import './global.js';
import { v$,compose,lastByIndex,generateBooleanArr } from './includes/helpers.js';
import './includes/handleFullReviewPop.js';
import handlePopup from './includes/popupForm';

import $ from 'jquery';


// elements
let showMoreReviews = v$('.reviews_page-main-show_all')[0],
    reviewContainer = v$('.reviews_page-main .wrapper_flex_wrap')[0];

//data

let reviewsUploadCount = 1;

//functions

const getLastId = () => {
    let lastItem  = lastByIndex(v$('.reviews-item'),2),
        id = lastItem.getAttribute('data-item-id');
    return id
}

const sendRequest = (id) => {
    let responseData = null;
    //here we send request to server
    if(process.env.NODE_ENV === 'development'){
        responseData = $.ajax('../data/reviews.json');
    }else{
        responseData = $.ajax(`get-reviews?batchNumber=${reviewsUploadCount}`);
    }
    return responseData;
}
const parseObject = response => ({
    status:response.status,
    reviews:Object.values(response.reviews)
});
const renderAllReviews = ({status,reviews}) => {
    reviews.forEach( item => {
        let rateArr = generateBooleanArr(item.rate,5);
        const innerHtml = `
            <div class="reviews-item-content">
                <div>
                    <span class="date">${item.date}</span>
                    <span class="reviews-mark starrr_small">
                        <span class="fa ${rateArr[0] ? 'fa-star' : 'fa-star-o'}" href=""></span>
                        <span class="fa ${rateArr[1] ? 'fa-star' : 'fa-star-o'}" href=""></span>
                        <span class="fa ${rateArr[2] ? 'fa-star' : 'fa-star-o'}" href=""></span>
                        <span class="fa ${rateArr[3] ? 'fa-star' : 'fa-star-o'}" href=""></span>
                        <span class="fa ${rateArr[4] ? 'fa-star' : 'fa-star-o'}" href=""></span>
                    </span>
                </div>
                <span class="reviews-name">${item.personName}</span>
                <span class="reviews-impression">${item.title}</span>
                <div class="reviews-full_content">${item.text}</div>
                <p>${item.shortText ? item.shortText : item.text }</p>
                <span class="reviews-full${item.shortText ? '' : ' btn_hide' }" href="">${process.env.NODE_ENV === 'development' ? item.btnText : window.JSI18N.t('frontend.reviews','expand')}</span>
            </div>
        `;
        let reviewsItem = document.createElement('div');
        reviewsItem.className = 'reviews-item';
        // reviewsItem.setAttribute('data-item-id',item.id);
        reviewsItem.innerHTML = innerHtml;
        reviewContainer.appendChild(reviewsItem);
    });
    reviewsUploadCount++;
    return status;
};
const controlBtn = status => {
    showMoreReviews.style.display = status ? 'block' : 'none';
};

const renderFetchedReviews = compose(
    controlBtn,
    renderAllReviews,
    parseObject
);

// listeners
showMoreReviews.addEventListener('click',() => {
    let id = getLastId();
    sendRequest(id).then(data => {
        renderFetchedReviews(data);
    })
});


//handle review poup on review page
handlePopup(v$('#review')[0],v$('.review_open')[0]);
